<template>
  <q-dialog v-model="alert" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="delete" color="negative" text-color="white" />
        <span class="q-ml-sm">Do you want to permanent delete {{ name }} module?</span>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="warning" v-close-popup />
        <q-btn flat :loading="isSubmitted" label="Confirm" color="positive" @click="confirmDelete" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useQuasar } from 'quasar'  
import { ref } from 'vue'
import axios from 'axios'
import EventBus from "@/EventBus"

export default {
  
  setup () {
    const token = ref(window.$cookies.get(process.env.VUE_APP_API_KEY).token)
    const $q = useQuasar()
    const backdropFilter = ref('grayscale(100%)')
    const alert = ref(false)
    const isSubmitted = ref(false)
    const moduleId = ref(null)
    const name = ref(null)

      
    EventBus.on("deleteModuleModal",(val) => {
        alert.value = val.status
        moduleId.value = val.obj.id
        name.value = val.obj.name
    })

    const confirmDelete = () => {
      var formData = {
           "module_id":moduleId.value.trim(),
        }

      isSubmitted.value = true; 
      axios.post(process.env.VUE_APP_API_URL + '/module/delete',formData,{
        headers: { 'Authorization': `Bearer ${token.value}`},
      }).then((response) => {
          isSubmitted.value = false
          confirm.value = false
          $q.notify({
            color: 'positive',
            textColor: 'white',
            icon: 'check_circle',
            message: response.data.message
          })
          EventBus.emit("refreshModuleData")
        }).catch((e) => {
         isSubmitted.value = false
         $q.notify({
            color: 'negative',
            textColor: 'white',
            icon: 'warning',
            message: e.response.data.message
          })
      })
    }

    return {
      token,
      alert,
      backdropFilter,
      isSubmitted,
      moduleId,
      name,
      confirmDelete
    }

  },

}
</script>